import type { SelectField } from '@payloadcms/plugin-form-builder/types'
import type { Control, FieldErrorsImpl } from 'react-hook-form'

import { Label } from '@/components/ui/label'
import {
  Select as SelectComponent,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import React from 'react'
import { Controller } from 'react-hook-form'

import { Error } from '../Error'
import { Width } from '../Width'

export const Select: React.FC<
  SelectField & {
    control: Control
    errors: Partial<FieldErrorsImpl>
  }
> = ({ name, control, errors, label, options, required, width, defaultValue }) => {
  const placeholder = `Select ${label}${required ? ' *' : ''}`
  const initialValue =
    typeof defaultValue === 'string' && defaultValue.length > 0 ? defaultValue : undefined

  return (
    <Width width={width}>
      <Label className="sr-only" htmlFor={name}>
        {label}
        {required && <span className="sr-only"> (required)</span>}
      </Label>
      <Controller
        control={control}
        defaultValue={initialValue}
        name={name}
        render={({ field: { onChange, value } }) => {
          const selectedValue = typeof value === 'string' && value.length > 0 ? value : undefined
          const controlledValue = options.find((t) => t.value === selectedValue)

          return (
            <SelectComponent onValueChange={(val) => onChange(val)} value={controlledValue?.value}>
              <SelectTrigger className="w-full text-[18px]" id={name}>
                <SelectValue placeholder={placeholder} />
              </SelectTrigger>
              <SelectContent>
                {options.map(({ label, value }) => {
                  return (
                    <SelectItem className="text-[18px]" key={value} value={value}>
                      {label}
                    </SelectItem>
                  )
                })}
              </SelectContent>
            </SelectComponent>
          )
        }}
        rules={{ required }}
      />
      {errors[name] && <Error name={name} />}
    </Width>
  )
}
